const DISCOVERY_KEY_PREFIX = 'eliteedge_beta_notification_discovery_v1';
export const NOTIFICATION_LOGIN_GENERATION_KEY = 'eliteedge_notification_login_generation_v1';

function storageKey(userId) {
  return `${DISCOVERY_KEY_PREFIX}:${encodeURIComponent(String(userId || ''))}`;
}

export function createLoginGeneration() {
  if (typeof window === 'undefined') return '';
  const generation = window.crypto?.randomUUID?.()
    || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  try {
    window.sessionStorage.setItem(NOTIFICATION_LOGIN_GENERATION_KEY, generation);
  } catch {
    return generation;
  }
  return generation;
}

export function readLoginGeneration() {
  try {
    return window.sessionStorage.getItem(NOTIFICATION_LOGIN_GENERATION_KEY) || '';
  } catch {
    return '';
  }
}

export function clearLoginGeneration() {
  try {
    window.sessionStorage.removeItem(NOTIFICATION_LOGIN_GENERATION_KEY);
  } catch {
    // Logout continues when session storage is unavailable.
  }
}

export function wasPromptedThisLogin(userId, generation) {
  if (!userId || !generation) return true;
  try {
    const state = JSON.parse(window.localStorage.getItem(storageKey(userId)) || 'null');
    return state?.lastPromptedGeneration === generation;
  } catch (storageError) {
    console.warn('Notification discovery state could not be read:', storageError?.message);
    return false;
  }
}

export function recordPromptAction(userId, generation, action) {
  if (!userId || !generation) return;
  try {
    window.localStorage.setItem(storageKey(userId), JSON.stringify({
      schemaVersion: 1,
      lastPromptedGeneration: generation,
      lastAction: action,
      updatedAt: new Date().toISOString(),
    }));
  } catch (storageError) {
    console.warn('Notification discovery state could not be saved:', storageError?.message);
  }
}
